/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection } from '@apollo/src/types';
import { Context, useCategoryFactory, UseCategoryFactoryParams } from '@vue-storefront/core';

export interface CategorySearchParams {
  collectionHandle?: string;
  [key: string]: any;
}

const params: UseCategoryFactoryParams<Collection, CategorySearchParams> = {
  categorySearch: async (context: Context, params: CategorySearchParams) => {
    if (params.collectionHandle) {
      const response = await context.$shopify.api.getCollectionByHandle({
        collectionHandle: params.collectionHandle,
      });
      return response?.data?.collection ? [response.data.collection] : [];
    }

    return context.$shopify.api.searchCollections(params);
  },
};

const useCategory = useCategoryFactory<Collection, CategorySearchParams>(params);

export default useCategory;
